import moment from 'moment-timezone';
import {environment} from "environments";

(() => {
  class PatientProfileNotesListController {
    constructor($interval, $rootScope, $scope, ngDialog, Users, Services, MedicationService) {
      'ngInject';
      Object.assign(this, {
        $interval,
        $scope,
        ngDialog,
        Users,
        Services,
        MedicationService,
        pagination: {
          offset: 0,
          limit: 5
        },
        visits: [],
        showAll: false,
        total: 0,
        patientNotesCollapsed: false,
        patientNotesPoll: null,
        makingApiCall: false,
        refreshing: false,
        BOD_1750: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV), //BOD-1750-Wegovy-and-Mounjaro-product label style
        BOD_1752: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV), //BOD-1752-clear view status expired icon
        visitExpiredCodes: ['expired']
      });
      $scope.$on('$destroy', () => {
        if (this.patientNotesPoll) {
          $interval.cancel(this.patientNotesPoll);
        }
      });
      $scope.$on('treatment:submitted', (event, medications = []) => {
        const visit = _.find(this.visits, {
          id: parseInt(this.currentVisit.id)
        });

        if (visit) {
          visit.prescribed_medication_names = medications.map(m => m.name);
        }
      });

      $rootScope.$on('visit:photo-deleted', () => {
        this.loadPatientNotes(this.showAll, true);
      });

      $scope.$on('visit:completed', () => {
        this.visits = [];
        this.pagination = {
          offset: 0,
          limit: 5
        };
        this.load();
      });
    }

    formatDate(iso_date) {
      if (!iso_date) return null;
      const formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
      return formatted_date;
    }

    makeCollapsed() {
      this.patientNotesCollapsed = true;
    }

    makeUncollapsed() {
      if (this.total > 0) {
        this.patientNotesCollapsed = false;
      } else {
        this.openPatientProfileNotes(this.currentVisit.user.id, this.currentVisit.id, null);
      }
    }

    hasMoreVisits() {
      return this.loading || this.visits.length < this.pagination.total;
    }

    $onInit() {
      this.load();
      this.loadPatientNotes(false, false);
      this.refreshPatientNotes();
    }

    load() {
      this.loading = true;
      this.Users.getHistory(this.currentVisit.user.id, this.pagination).then(({
        data
      }) => {
        const {
          data: visits,
          pagination
        } = data; // we commented this temporary code
        // because we don't need to do this anymore
        // now we are using the filter "paid = true"
        // var visitsFiltered = [];
        // data.data.forEach((visit) => {
        //   if (visit.admin_status === 9.9) {
        //     if (visit.paid) {
        //       visitsFiltered.push(visit);
        //     }
        //   } else {
        //     visitsFiltered.push(visit);
        //   }
        // });
        // this.visits = this.visits.concat(visitsFiltered.map(v => new Order(v)));

        this.visits = this.visits.concat(visits.map(v => new Order(v)));
        if(this.BOD_1750){
          this.visits.forEach(visit => {
            if(visit.prescribed_medication){
              visit.prescribed_medication.forEach(prescribedMed => prescribedMed.style = this.MedicationService.getMedicationLabelStyle(visit.service.code, prescribedMed.code))
            }
          });
        }
        Object.assign(this.pagination, pagination);
        this.pagination.offset += this.pagination.limit;
        this.mostRecentVisitId = this.visits.length ? this.visits[0].id : this.currentVisit.id;
      }).catch(err => console.log(err)).finally(() => {
        this.loading = false;
      });
    }

    refreshPatientNotes() {
      if (this.patientNotesPoll) {
        this.$interval.cancel(this.patientNotesPoll);
      }

      this.patientNotesPoll = this.$interval(() => {
        if (this.makingApiCall) {
          return;
        }

        if (this.total > this.patientNotes.length) {
          this.loadPatientNotes(false, true);
        } else {
          this.loadPatientNotes(true, true);
        } // Patient notes on the side bar will refresh automatically every minute

      }, 60000);
    }

    openPatientProfileNotes(patient, visitId, patientNote) {
      // If popup is already opened, we do not open again
      if (this.patientNotesDialog && this.ngDialog.isOpen(this.patientNotesDialog.id)) return;
      this.patientNotesDialog = this.ngDialog.open({
        templateUrl: 'app/components/patient-profile-notes/patient-profile-notes.html',
        // To not allow the user closes the modal without explicitely to have some action
        // select the X to close
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,
        // To make possible doctor still be able to use the screen behind
        overlay: false,
        controller: 'PatientProfileNotesController',
        controllerAs: 'patProNotes',
        className: 'ngdialog-theme-default pat-pro-notes',
        data: {
          patient,
          visitId,
          patientNote
        }
      });
    } // Parameters:
    //
    //    all => true when we want to load all notes
    //           false when we want to show only 3 notes (first time we load)
    //
    //    refreshing => when application is refreshing must be true
    //                  when user click button must be false
    //    this is to see if we show the button reloading or not
    //


    loadPatientNotes(all, refreshing) {
      this.refreshing = refreshing;
      this.showAll = all;
      this.makingApiCall = true;
      var pagination = {
        limit: 999999
      };
      this.Users.getPatientNotes(this.currentVisit.user.id, pagination).then(data => {
        const LIMIT = 2;
        var allPatientNotes = data.data.data;
        var maxNotes;
        this.patientNotes = [];
        this.total = 0; //console.log('Patient Notes', allPatientNotes);

        if (allPatientNotes && allPatientNotes.length > 0) {
          allPatientNotes.sort(function (a, b) {
            var timestampA = !a.modified ? a.created : a.modified;
            var timestampB = !b.modified ? b.created : b.modified;
            return timestampB - timestampA;
          });
          this.total = allPatientNotes.length;

          if (all) {
            maxNotes = allPatientNotes.length;
          } else {
            maxNotes = allPatientNotes.length > LIMIT ? LIMIT : allPatientNotes.length;
          }

          for (var i = 0; i < maxNotes; i++) {
            this.patientNotes.push(allPatientNotes[i]);
          }
        }

        if (this.total === 0) {
          this.patientNotesCollapsed = true;
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        this.makingApiCall = false;
      });
    }

    showVisitExpiredIcon(visit){
      const { code } = { ...visit?.status_description };
      return this.visitExpiredCodes.includes(code);
    }

    showVisitAutoRefillCancelldIcon(visit){
      const { status, reason, code } = { ...visit?.status_description };
      return   status >= 9 && status <= 10 && reason && code !== 'expired';
    }
  }

  PatientProfileNotesListController.$inject = ["$interval", "$rootScope", "$scope", "ngDialog", "Users", "Services", "MedicationService"];
  angular.module('pims').component('visitHistoryPatientNotes', {
    templateUrl: 'app/views/visits/detail/sections/history/visit-history-patient-notes.html',
    controller: PatientProfileNotesListController,
    bindings: {
      currentVisit: '=',
      timezone: '='
    }
  });
})();
